module.exports = {
  "country": "AU",
  "artist": "Jessica Mauboy",
  "song": "We Got Love",
  "year": "2018",
  "place": "20",
  "spotify": "7kqujRWNEBhrpYt0eV0uw5"
};